<template>
    <div class="px-4">
        <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined ><v-icon>mdi-arrow-left-bold</v-icon> Volver Atras </v-btn>
        <h4 class="text-center purple--text">Depositos de depositos </h4>  
        <p class="text-center mt-0"> Aqui puede subir los depositos de un deposito en caso que se tenga varios archivos </p> 

        <v-tooltip bottom >
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" class="mb-2" outlined text color="purple" @click="openDeta()"> <v-icon>mdi-plus</v-icon> Agregar comprobante </v-btn>
            </template>
            <span> Agregar comprobante </span>
        </v-tooltip>

        <v-data-table :loading="loading" :headers="headers" :items="desserts" disable-pagination hide-default-footer :items-per-page="5" class="elevation-1">
            <template v-slot:[`item.deleted_at`]="{ item }">
                <p class="red--text"> {{ item.deleted_at }} </p>
            </template>
            <template v-slot:[`item.estado`]="{ item }">
                <p class=""> {{ getEstado(item.estado) }} </p>
            </template>
            <template v-slot:[`item.sede`]="{ item }">
                <p> {{ item.sede.nombre }} </p>
            </template>
            <template v-slot:[`item.opt`]="{ item }">
                <div style="min-width: 150px;">   
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" tile small text color="orange" @click="obtenerDetalles(item.id)"> <v-icon>mdi-eye</v-icon> </v-btn>
                        </template>
                        <span> Ver detalles </span>
                    </v-tooltip>
                    <!-- <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn :disabled="item.estado==3" v-bind="attrs" v-on="on" tile small text color="green" @click="openDeta(item.id)"> <v-icon>mdi-plus</v-icon> </v-btn>
                        </template>
                        <span> Agregar comprobante </span>
                    </v-tooltip> -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn :disabled="item.estado==3 || item.estado==1" v-bind="attrs" v-on="on" tile small text color="blue" @click="verificaropen(item)"> <v-icon>mdi-check</v-icon> </v-btn>
                        </template>
                        <span> Verificar </span>
                    </v-tooltip>
                      
                </div>
            </template>
        </v-data-table> 
        
        <registrarv2 ref="refagregarv2" v-on:success="cargarDatos"/>
        <verdepo ref="refverdepo" />
    </div>
  </template>

<script> 
import registrarv2 from '../cajas/registrarDepodepo.vue'; 
import verdepo from './verdepo.vue'; 
import xaxios from '@/xaxios';

export default {
    components:{ registrarv2,verdepo },
    data () {
        return {
            headers: [ 
                { text: '#', value: 'nro' },
                { text: 'Monto recaudado', value: 'monto_recaudado' },
                { text: 'Monto depositado', value: 'monto_depositado' },
                { text: 'Sede', value: 'sede' },
                { text: 'Creador', value: 'created_by' },
                { text: 'Registro', value: 'created_at' },
                { text: 'Comprobante', value: 'comprobante' },
                { text: 'Deposito', value: 'fecha_deposito' }, 
                { text: 'Estado', value: 'estado' },
                { text: '', value: 'opt' },
            ],
            desserts: [],
            eliminados: false,
            loading: false,
            cajaid: null,
            depoid: null,
        }
    }, 
    methods:{
        opennominaciones(){
            this.$router.push('/nominaciones')
        },  
        async cargarDatos(){
            let depoid = this.$route.query.depoid; 
            this.loading = true;
            this.desserts = [];
            // api/v1/esam/depositocajas/54?subdepositos=true
            let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/depositocajas/${depoid}?subdepositos=true`; 
            const res = await xaxios.get(url).then(x=>x).catch(x=>x);
            window.console.log('deposs',res.data);
            if(res && res.data && res.data.depositos_hijos ) {
                res.data.depositos_hijos.map((x,i)=>{
                    x,
                    x.nro = i+1
                })
                this.desserts = res.data.depositos_hijos;
            } 
            this.loading = false;
        }, 
        async obtenerDetalles(depoid){  
            this.$refs.refverdepo.openmodal(depoid); 
        },
        openDeta(){
            this.$refs.refagregarv2.openmodal(this.cajaid, this.depoid);
        },
        getEstado(est){
            if (est == 1) return 'recaudado';
            else if (est == 2) return 'depositado';
            else if (est == 3) return 'verificado';
            else return '??';
        },
        async verificaropen(item){
            let nameroute = this.$route.query.other;
            window.console.log('item',nameroute);
            if(nameroute){
                let message = {
                    title: 'Para indicar como verificado, valide esta accion:',
                    body: '<br> <b>NOTA:</b> Primero verifique el comprobante(con el boton del ojito) que este correcto y luego confirme la verificacion, es su responsabilidad marcar verificado ',
                };
                let options = {
                    html: true,
                    okText: 'Verificado',
                    cancelText: 'Cancelar',
                    reverse: true,
                    type: 'hard',
                    verification: 'verificado',
                    verificationHelp: 'Escriba "[+:verification]" para proceder.',
                    loader: true,
                };
                let dialogo = await this.$dialog.confirm(message, options).then(d=>d).catch(e=>e);
                if(dialogo){
                    // 
                    let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/depositocajas/${item.id}`; 
                    const res = await xaxios.patch(url).then(x=>x).catch(x=>x);
                    window.console.log(res);
                    dialogo.close();
                    this.cargarDatos();
                }
            }else{
                this.$root.$notify.show(`La verificacion lo debe realizar la sede de destino`, {color:'green',y: 'left',});
            } 
        },
    },
    async mounted(){ 
        this.cajaid = this.$route.query.idcaja; 
        this.depoid = this.$route.query.depoid; 
        this.cargarDatos();
        
    }
}
</script>